<!-- 申请公证页面 -->
<template>
  <div>
    <van-dialog
      v-model="show"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <div class="text-right" @click="showFn">
        <van-icon name="cross" size="0.4rem" color="#666" />
      </div>
      <div class="txt">
        提示
      </div>
      <div class="title">
        <p>系统审核中，请稍后重试~</p>
      </div>
      <div class="mt10" @click="showFn" style="display: flex;justify-content: center;">
        <van-button style="width: 50%;" size="large" type="info" block round>好的</van-button>
      </div>
    </van-dialog>
    <div class="result-container text-center">
      <img class="state-img" :src="notarizationImg" />
      <div class="rem30 mt35 text-left">
        <span>为保证此次交易的有效性，此次交易由四川省成都市律政公证处提供公证服务</span>
      </div>
      <div class="result-btn">
        <van-button round block color="#4D7BFE" class="btn" @click="toApply">
          <span class="rem34">去公证</span>
        </van-button>
      </div>

    </div>
  </div>
  
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import { Button, Toast } from 'vant'
import wx from 'weixin-js-sdk';
import { dealerDetailApi } from '@/apis/kdb';

Vue.use(Button)
export default {
  data() {
    return {
      show: false,
      notarizationImg: require('@/assets/images/kdb/notarization.png'),
    }
  },
  created() {
    this.$nextTick(() => {
      this.userLcApplGooodsFun('init')
    })
    
  },
  computed: {
    ...mapState({
      loanNo: (state) => state.borrow.loanNo,
      faceToken: (state) => state.borrow.faceToken,
      productCode: (state) => state.common.productCode,
      applySeq: (state) => state.borrow.applySeq,
      notarizationApplyInfo: (state) => state.borrow.notarizationApplyInfo,
    }),
  },
  methods: {
    showFn() {
      this.show = false
    },
    async userLcApplGooodsFun(type){
      const loadingToast = Toast.loading({
        message: '查询中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let res = await dealerDetailApi({ loanNo: this.loanNo })
        if (res && res.code == 200) {
            this.productInfo = res.data
            try {
              this.$store.commit('SET_NOTARIZATION_APPLY_INFO', {
                weiXinSchemaUrl: this.productInfo.weiXinSchemaUrl || '',
                weiXinHttpUrl: this.productInfo.weiXinHttpUrl || '',
                expireTime: this.productInfo.expireTime || '',
                navigateParam: this.productInfo.navigateParam || ''
              })
            } catch (error) {}

            loadingToast.clear()

            if(type != 'init') {
              if(!this.productInfo.navigateParam) {
                // 弹框提示
                this.show = true;
              }else{
                // location.href = this.productInfo.weiXinSchemaUrl
                // 判断是否在微信环境中
                if (typeof wx !== 'undefined' && wx.miniProgram) {
                      // 跳转公证小程序
                      wx.miniProgram.reLaunch({
                        url: `/pages/new/my/certification/index?appId=${this.productInfo.navigateParam.appId}&envVersion=${this.productInfo.navigateParam.envVersion}&path=${this.productInfo.navigateParam.path}&lzDossierId=${this.productInfo.navigateParam.extraData.lzDossierId}&type=${this.productInfo.navigateParam.extraData.type}&idCard=${this.productInfo.navigateParam.extraData.idCard || ''}`
                      })
                } else {
                    location.href = this.productInfo.weiXinSchemaUrl
                }
              }
            }
        } else {
          this.$common.toast(res.msg)
        }
      } catch (error) {}
    },
    toApply() {
      this.userLcApplGooodsFun()
    },
  },
}
</script>

<style lang="less" scoped>
.result-container {
  padding: 0 0.42rem;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  position: relative;
  .state-img {
    margin-top: 1rem;
    width: 4.22rem;
    height: 3.26rem;
  }
  .result-btn {
    position: absolute;
    margin-top: 0.82rem;
    bottom: 2.3rem;
    width: calc(100% - 0.84rem);
  }
  .btn {
    margin-top: 0.48rem;
  }
}
/deep/ .van-dialog {
  padding: 0.4rem;
  width: 6rem;
  font-size: 0.28rem;
}
.txt {
  width: 6rem;
  text-align: center;
  font-size: 0.35rem;
}
.title {
  text-align: center;
  font-size: 0.32rem;
  padding: 0.4rem 0;
}
</style>
